import { render, staticRenderFns } from "./Tabla.vue?vue&type=template&id=0c881cbb&scoped=true&"
import script from "./Tabla.vue?vue&type=script&lang=js&"
export * from "./Tabla.vue?vue&type=script&lang=js&"
import style0 from "./Tabla.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Tabla.vue?vue&type=style&index=1&id=0c881cbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c881cbb",
  null
  
)

export default component.exports